import { Grid, makeStyles, Paper, TextField, Typography } from "@material-ui/core";
import Autocomplete from '@material-ui/lab/Autocomplete';
import { findIndex, isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { useCommittees } from "../../../hooks/useCommittees";
import { Select } from "../../Common/Select";
import { Container } from "./styles";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: 40, 
    marginBottom: 40
  },
  title: {
    ...theme.typography.subtitle2,
    marginBottom: 20 
  }
}));

const Info = ({ 
  t, 
  onChangeData, 
  committee, 
  spinner, 
  disabled, 
  filteredList,
  handleSearchMember }) => {
  const classes = useStyles();
  const [value, setValue] = useState({});
  const [options, setOptions] = useState([]);
  const [chairperson, setChairperson] = useState();
  const [coChair, setCoChair] = useState();
  const [secretary, setSecretary] = useState();
  const { getCommittees, sanitizeForTable, committeesList } = useCommittees({
    spinner,
  });

  useEffect(() => {
    getCommittees({
      columnNameOrder: "name",
      typeOrder: null,
    });
  }, []);

  useEffect(() => {
    onChangeData(value);
    value.chairperson && setChairperson(value.chairperson);
    value.coChair && setCoChair(value.coChair);
    value.secretary && setSecretary(value.secretary);
  }, [value]);

  useEffect(() => {
    setOptions(filteredList);
  }, [filteredList]);

  const findCommitteesList = (committeeId) =>
    findIndex(committeesList, ["id", committeeId]);

  const fillCommittee = async (items) => {
    const subordinatedId = findCommitteesList(items.subordinated);
    setValue({
      emailCommittee: items.email,
      nameCommittee: items.name,
      chairperson: items.chairPerson,
      coChair: items.cochair,
      secretary: items.secretary,
      subordinate: subordinatedId !== -1 ? committeesList[subordinatedId] : {},
    });
  }; 

  useEffect(() => {
    if (!isEmpty(committee) && committeesList.length > 0) fillCommittee(committee);
  }, [committee, committeesList]);

  const [state, setState] = useState({
    value: "",
    errorText: t("forms.committee.required"),
    errorTextCochair: t("forms.committee.required"),
    errorTextChairperson: t("forms.committee.required"),
    errorTextSecretary: t("forms.committee.required"),
    hasError: false
  });

  const handleChange = (event) => {
    if (event.target.value !== "") {
      setValue({ 
        ...value, [event.target.name]: event.target.value, 
        errorText: ""
      });
      setState({ ...state, errorText: "",  hasError: false });
    } else {
      setState({ ...value, [event.target.value]: "", 
      errorText:  t("forms.committee.required"),
      errorTextChairperson:  t("forms.committee.required"),
      errorTextCochair:  t("forms.committee.required"),
      errorTextSecretary:  t("forms.committee.required")
     });
     event.preventDefault();
     setValue({ 
      ...value, [event.target.name]: event.target.value, 
      errorText: ""
    });
    }
  };

  const handleInputChange = (value) => {
    handleSearchMember(value);
  };

  const handleChangeSelect = (selected, name) => {
   if(selected == null)
  {
  if(name == "chairperson")
  {
    setState({ ...value, errorTextChairperson:  t("forms.committee.required"),  hasError: true});
    setValue({ ...value, [name]: null} );
  }

  if(name == "coChair")
  {
   setState({ ...value, errorTextCochair:  t("forms.committee.required"),  hasError: true});
   setValue({ ...value, [name]: null} );
  }

  if(name == "secretary")
  {
  setState({ ...value, errorTextSecretary:  t("forms.committee.required"),  hasError: true});
  setValue({ ...value, [name]: null} );
  }

  if(name == "subordinate")
  {
  setValue({ ...value, [name]: ""} );
  }
   } else {

      setValue({ ...value, [name]: selected} );
  
      if(name == "chairperson")
      {
        setState({ ...value, errorTextChairperson: "",  hasError: true});
      }
    
      if(name == "coChair")
      {
       setState({ ...value, errorTextCochair: "",  hasError: true});
      }
    
      if(name == "secretary")
      {
       setState({ ...value, errorTextSecretary:  "",  hasError: true});
      }
    }
  }

  return (
    <Paper
    elevation={1}
    className={classes.root}
    >
      <Typography className={classes.title}>
        {t("forms.committee.infoCommittee")}
      </Typography>
      <Container container spacing={3}>
        <Grid item lg={6} xs={12}>
          <TextField
            disabled={disabled}
            value={value.nameCommittee}
            autoComplete='nope' 
            name="nameCommittee"
            id="nameCommittee"
            label={t("forms.committee.nameCommittee")}
            defaultValue=""
            fullWidth
            onChange={handleChange}
            autoFocus={true}
            InputLabelProps={{ shrink: value.nameCommittee ? true : false }}
            required
            error={ value.nameCommittee ? false : true}
          />
        </Grid>
        <Grid item lg={6} xs={12}>
          <TextField
            disabled={disabled}
            value={value.emailCommittee}
            autoComplete='nope' 
            name="emailCommittee"
            id="emailCommittee"
            label={t("menu.managementProfiles.email")}
            defaultValue=""
            fullWidth
            onChange={handleChange}
            autoFocus={true}
            InputLabelProps={{ shrink: value.emailCommittee ? true : false }}
          />
        </Grid>
        <Grid item lg={6} xs={12}>
          <Autocomplete
            id="chairperson"
            autoComplete={false}
            options={options}
            getOptionLabel={(options) => {
              if(options.name && options.positionName) return `${options.name} - ${options.positionName}`;
              else if (options.name) return options.name;
              else return "";
            }}           
            onChange={(event, newValue) => handleChangeSelect(newValue, "chairperson")}
            onSelect={() => setOptions([])}
            getOptionSelected={(option, value) => option.id === value.id}
            onInputChange={_.debounce((event, newValue, reason) => {
              if(newValue.length > 2 && reason === "input") {
                handleInputChange(newValue)
              }else if(newValue === "") {
                setChairperson(newValue)
              }
            }, 500)}
            disabled={disabled}
            value={chairperson || ""}
            renderInput={(params) => (
              <TextField {...params} label={t("forms.committee.chairperson")} fullWidth 
                error={value.chairperson ? false : true} required={true}
              />
            )}
          />
        </Grid>
        <Grid item lg={6} xs={12}>
          <Autocomplete
            id="coChair"
            autoComplete={false}
            options={options}
            getOptionLabel={(options) => {
              if(options.name && options.positionName) return `${options.name} - ${options.positionName}`;
              else if (options.name) return options.name;
              else return "";
            }}
            onChange={(event, newValue) => handleChangeSelect(newValue, "coChair")}
            onSelect={() => setOptions([])}
            getOptionSelected={(option, value) => option.id === value.id}
            onInputChange={_.debounce((event, newValue, reason) => {
              if(newValue.length > 2 && reason === "input") {
                handleInputChange(newValue);
              } else if(newValue === "") {
                setCoChair(newValue)
              }
            }, 500)}
            disabled={disabled}
            value={coChair || ""}
            renderInput={(params) => (
              <TextField {...params} label={t("forms.committee.coChair")} fullWidth />
            )}
          />
        </Grid>
        <Grid item lg={6} xs={12}>
          <Autocomplete
            id="secretary"
            autoComplete={false}
            options={options}
            getOptionLabel={(options) => {
              if(options.name && options.positionName) return `${options.name} - ${options.positionName}`;
              else if (options.name) return options.name;
              else return "";
            }}
            onChange={(event, newValue) => handleChangeSelect(newValue, "secretary")}
            onSelect={() => setOptions([])}
            getOptionSelected={(option, value) => option.id === value.id}
            onInputChange={_.debounce((event, newValue, reason) => {
              if(newValue.length > 2 && reason === "input") {
                handleInputChange(newValue)
              } else if(newValue === "") {
                setSecretary(newValue)
              }
            }, 500)}
            disabled={disabled}
            value={secretary || ""}
            renderInput={(params) => (
              <TextField {...params} label={t("forms.committee.secretary")} fullWidth 
                error={value.secretary ? false : true} required={true}
              />
            )}
          />
        </Grid>
        <Grid item lg={6} xs={12}>
          <Select
            id="subordinate"
            options={committeesList ? sanitizeForTable(committeesList, []) : []}
            value={value.subordinate}
            setValue={(value) => handleChangeSelect(value, "subordinate")}
            label={t("forms.committee.subordinate")}
            disabled={disabled}
          />
        </Grid>
      </Container>
    </Paper>
  );
};

export default withTranslation()(Info);
